import { ZDate } from "./ZDate.js";
import { z } from "zod";
import { zArr, zNullable, zNum, zObj } from "./zodWrapper.js";
export const DeadweightVesselTypes = z.enum([
    "Bulk Carrier",
    "Combination carrier",
    "Container Ship",
    "Gas Carrier",
    "General Cargo",
    "LNG Carrier",
    "Refrigerated Cargo Carrier",
    "Tanker",
    "Wellboat",
]);
export const GrossTonnageVesselTypes = z.enum([
    "Cruise Passenger Ship",
    "REV",
    "RoRo Cargo Vehicle Carrier",
    "RoRo Cargo",
    "RoRo Passenger (High-speed craft)",
    "RoRo Passenger (Regular)",
]);
export const GrossTonnageOffshoreVesselTypes = z.enum(["CLV", "CSV", "PSV"]);
export const BollardPullOffshoreVesselTypes = z.enum(["AHTS"]);
export const VesselType = z.enum([
    ...DeadweightVesselTypes.options,
    ...GrossTonnageVesselTypes.options,
    ...GrossTonnageOffshoreVesselTypes.options,
    ...BollardPullOffshoreVesselTypes.options,
]);
export const GetCiiKpisDataArgs = zObj({
    plantId: zNum(),
    timestampGte: ZDate,
    timestampLt: ZDate,
});
export const DeadweightVesselInfo = zObj({
    vesselType: DeadweightVesselTypes,
    deadweightTonnes: zNullable(zNum()),
    distanceSailedNm: zNullable(zNum()),
});
export const GrossTonnageVesselInfo = zObj({
    vesselType: GrossTonnageVesselTypes,
    grossTonnage: zNullable(zNum()),
    distanceSailedNm: zNullable(zNum()),
});
export const BollardPullOffshoreVesselInfo = zObj({
    vesselType: BollardPullOffshoreVesselTypes,
    bollardPullTonnes: zNullable(zNum()),
    runningHours: zNullable(zNum()),
});
export const GrossTonnageOffshoreVesselInfo = zObj({
    vesselType: GrossTonnageOffshoreVesselTypes,
    grossTonnage: zNullable(zNum()),
    runningHours: zNullable(zNum()),
});
export const CiiType = z.union([
    DeadweightVesselInfo,
    GrossTonnageVesselInfo,
    BollardPullOffshoreVesselInfo,
    GrossTonnageOffshoreVesselInfo,
]);
export const CiiRating = z.enum(["A", "B", "C", "D", "E", "NA"]);
export const CiiKpisData = zObj({
    ciiAttained: zNullable(zNum()),
    ciiRating: CiiRating,
    ciiReference: zNullable(zNum()),
    ciiRequiredReductionPercentage: zNullable(zNum()),
    co2EmissionTonnes: zNullable(zNum()),
    vesselTypeData: CiiType,
});
export const GetCiiRatingTrendArgs = zObj({
    plantId: zNum(),
    opModeId: zArr(zNullable(zNum())),
    timestampGte: ZDate,
    timestampLt: ZDate,
});
export const CiiRatingBoundaryParamsType = zObj({ d1: zNum(), d2: zNum(), d3: zNum(), d4: zNum() });
export const CiiRatingTrend = zObj({
    data: zArr(z.tuple([ZDate, zNullable(zNum())])),
    ciiRequired: zNullable(zNum()),
    ciiRatingBoundaryParams: zNullable(CiiRatingBoundaryParamsType),
});
export const GetCiiRatingPerModeArgs = zObj({
    plantId: zNum(),
    timestampGte: ZDate,
    timestampLt: ZDate,
});
export const CiiRatingPerMode = zObj({
    ciiPerMode: zArr(zObj({ opModeId: zNullable(zNum()), ciiAttained: zNullable(zNum()) })),
    ciiRequired: zNullable(zNum()),
    ciiRatingBoundaryParams: zNullable(CiiRatingBoundaryParamsType),
});
export const CiiMetricPerMode = zObj({
    opModeId: zNullable(zNum()),
    co2EmissionTonnes: zNullable(zNum()),
    runningHours: zNullable(zNum()),
    distanceNm: zNullable(zNum()),
});
//# sourceMappingURL=cii.js.map